const useCheckLandingContent = (
    { statusCode, message } = { statusCode: 404, message: 'Not found' }
) => {
    const contentStore = useContentStore();
    const { landingPageContents } = contentStore;
    const route = useRoute();
    if (!landingPageContents) {
        showError({ statusCode, message });
    } else if (landingPageContents?.redirectUrl) {
        return navigateTo(
            {
                path: landingPageContents.redirectUrl,
                query: route.query,
            },
            { redirectCode: landingPageContents.redirectErrorCode ?? 301 }
        );
    } else if (landingPageContents?.redirectErrorCode) {
        showError({
            statusCode: landingPageContents.redirectErrorCode,
            message,
        });
    }
};

export default useCheckLandingContent;
